(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-login"] && !Shopify.designMode) return;
  try {
    
  const resetLinks = document.querySelectorAll('.reset-toggle');
  const loginForm = document.querySelector('.Account__form-login');
  const resetForm = document.querySelector('.Account__form-reset-password');

  resetLinks.forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      loginForm.classList.toggle('Account__form-hidden');
      resetForm.classList.toggle('Account__form-hidden');
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  // Fetch and insert product recommendations
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    


    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url).then(response => response.text()).then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;

// Re-initialize carousels after new content is added
        initializeCarousels();
      }
    }).catch(e => {
      console.error(e);
    });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
